import { AbstractItem } from "./AbstractItem";

export class InvisibleItem extends AbstractItem {
  constructor(typeKey: string, public readonly source: any) {
    super(typeKey);
  }
 
  protected createCloneInstance(): InvisibleItem {
    return new InvisibleItem(this.typeKey, this.source);
  }
}
